import Axios from "axios";
import { errorResponse } from "../../../../utils/apiHelpers/apiHelpers";
import { appConfigs } from "../../../../utils/configurations";

type FileType = 'zip' | 'json' | 'app' | 'pesp' | 'png' | 'txt' | 'pdf' | 'jpg' | 'mp3' | 'doc' | 'docx' | 'xls' | 'xlsx' | 'ppt' | 'pptx' | 'csv' | 'html' | 'css' | 'js' | 'ts' | 'java' | 'cpp' | 'c' | 'py' | 'php' | 'sql' | 'xml' | 'svg' | 'gif' | 'bmp' | 'avi' | 'mp4' | 'mov' | 'wmv' | 'wav' | 'ogg' | 'flac' | 'aac' | 'wma' | 'ogg' | 'ogg' | 'wav' | 'flac' | 'aac' | 'wma' | 'ogg' | 'midi' | 'mpg' | 'mpeg' | 'mkv' | 'rar' | '7z' | 'tar' | 'gz' | 'bz2' | 'exe' | 'bat' | 'msi' | 'dll' | 'jar' | 'apk' | 'ipa' | 'deb' | 'rpm' | 'woff' | 'woff2' | 'ttf' | 'otf' | 'eps' | 'ai' | 'psd' | 'indd' | 'cdr' | 'fla' | 'swf' | 'unity3d' | 'blend' | 'max' | '3ds' | 'obj' | 'stl' | 'fbx' | 'dae' | 'dwg' | 'dxf' | 'skp' | 'sldprt' | 'sldasm' | 'step' | 'iges' | 'prt' | 'asm' | 'iso' | 'img' | 'bin' | 'cue' | 'mdf' | 'm3u' | 'pls' | 'aspx' | 'jsp' | 'php' | 'cgi' | 'dll' | 'class' | 'sh' | 'bat' | 'pl' | 'jsx' | 'tsx' | 'vue' | 'php' | 'asp' | 'jsp' | 'aspx' | 'erb' | 'jsp' | 'cfm' | 'cgi' | 'pl' | 'lua' | 'rb' | 'cs' | 'vb' | 'f#' | 'swift' | 'kotlin' | 'dart' | 'scala' | 'groovy' | 'r' | 'go' | 'rust' | 'elixir' | 'haskell' | 'typescript' | 'coffeescript' | 'perl' | 'powershell' | 'batch' | 'bash' | 'zsh' | 'makefile' | 'cmake' | 'gradle' | 'dockerfile' | 'yaml' | 'ini' | 'cfg' | 'jsonc' | 'yml' | 'toml' | 'conf' | 'properties' | 'jsx' | 'tsx' | 'vue' | 'md' | 'markdown' | 'rst' | 'adoc' | 'tex' | 'rtf' | 'wps' | 'odt' | 'ott' | 'docx' | 'dotx' | 'rtf' | 'odp' | 'otp' | 'pptx' | 'potx' | 'pps' | 'ppsx' | 'key' | 'sketch' | 'xd' | 'ps' | 'eps' | 'pdf' | 'xps' | 'odp' | 'otp' | 'sxd' | 'std' | 'uof' | 'html' | 'mht' | 'mhtml' | 'htm' | 'xml' | 'dtd' | 'xsd' | 'xsl' | 'svg' | 'xhtml' | 'plist' | 'rtf' | 'txt' | 'csv' | 'log' | 'md' | 'xml' | 'json' | 'yaml' | 'yml' | 'tsv' | 'wks' | '123' | 'wk1' | 'wk3' | 'wk4' | 'xlk' | 'xls' | 'xlm' | 'xlt' | 'xlw' | 'xla' | 'xlsx' | 'xlsm' | 'xltm' | 'xltx' | 'ods' | 'ots' | 'qbw' | 'qbb' | 'qbm' | 'qbi' | 'qbr' | 'wlmp' | 'camproj' | 'mxf' | 'asf' | 'vob' | 'mts' | 'm2ts' | 'mod' | 'tod' | 'dv' | 'mpg' | 'mpeg' | 'avi' | 'wmv' | 'mp4' | 'mov' | 'm4v' | 'mkv' | 'flv' | 'f4v' | 'swf' | '3gp' | 'webm' | 'gif' | 'mp3' | 'wma' | 'wav' | 'flac' | 'aac' | 'ogg' | 'amr' | 'm4a' | 'ape' | 'aiff' | 'au' | 'mid' | 'midi' | 'rm' | 'ogg' | 'ra' | 'ram' | 'mp2' | 'mka' | 'ogg' | 'ape' | 'mpc' | 'cda' | 'snd' | 'aif' | 'aac' | 'flac' | 'ac3' | 'dts' | 'aob' | 'mpg' | 'mpeg' | 'ts' | 'mkv' | 'mp4' | 'm4v' | 'flv' | 'f4v' | 'mov' | 'avi' | 'wmv' | 'rmvb' | 'rm' | '3gp' | 'dv' | 'vob' | 'mts' | 'm2ts' | 'swf' | 'gif' | 'jpg' | 'jpeg' | 'png' | 'bmp' | 'tiff' | 'psd' | 'thm' | 'tif' | 'webp' | 'svg' | 'ai' | 'eps' | 'cdr' | 'ico' | 'pcx' | 'raw' | 'wmf' | 'emf' | 'dwg' | 'dxf' | 'dgn' | 'skp' | '3dm' | 'stp' | 'iges' | 'step' | 'brep' | 'stl' | 'obj' | 'ply' | 'wrl' | '3ds' ;

export function getSoftwares(
  me: any,
  callbackFnSuccess?: any,
  callbackFnFailure?: any,
  page: number=1,
  searchText?: string,
  filters?: any[any],
  systemSwId?: string ) 
{
  return async (dispatch: any) => 
  {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let filtersObj: any = [];
    filters && filters["status"] != null
      ? (filtersObj = { statusFilter: filters["status"] })
      : (filtersObj = {});

    Axios.get(appConfigs.server.URL + "/ui/api/software-listing",
      {
          params: {
            orgId: null,
            systemSwId: systemSwId,
            searchText: searchText,
            scope: "all",
            page: page,
            pageSize: appConfigs.tables.pageSize
          },
      }
    ).then((response) => 
    {
        if (callbackFnSuccess != null) 
        {
          callbackFnSuccess(response.data.data.softwareList);
        }
        dispatch({
          type: "SOFTWARES_GET_SUCCESS",
          payload: { data: response.data.data.softwareList, page: page },
        });
    }).catch(function (error) 
    {
        if (callbackFnFailure != null) 
        {
          callbackFnFailure(me, error);
        }
        errorResponse(me, error);
    });
  };
}

export function softwaresSetSearch(searchText: string) 
{
  return (dispatch: any) => 
  {
    dispatch({ type: "SOFTWARE_SET_SEARCH", searchText: searchText });
  };
}

export function softwareSetPagination(onPaginationChange: any) 
{
  return (dispatch: any) => 
  {
    dispatch({type: "SOFTWARES_SET_PAGINATION", onPaginationChange: onPaginationChange});
  };
}

export function setTab(tabNumber: string) 
{
  return (dispatch: any) => 
  {
    dispatch({ type: "SET_TAB", tabNumber: tabNumber });
  };
}

export function openDrawer(title: string, width: number, record: any) 
{
  return (dispatch: any) => 
  {
    dispatch({type: "OPEN_DRAWER",payload: { title: title, width: width, record: record }});
  };
}

export function closeDrawer() 
{
  return (dispatch: any) => 
  {
    dispatch({ type: "CLOSE_DRAWER" });
  };
}

export function drawerTabChange(activeTab: string) 
{
  return (dispatch: any) => 
  {
    dispatch({ type: "DRAWER_TAB_CHANGE", activeTab: activeTab });
  };
}

export function getAllSoftwaresList() 
{
  return (dispatch: any) => 
  {
    Axios.get(appConfigs.server.URL + "/ui/api/software-listing", {
      responseType: "json",
      headers: {},
      params: {
        page: 1,
        pageSize: appConfigs.tables.pageSize,
      },
    }).then((response) => 
    {
        let softwares = response.data.data.softwareListing;
        dispatch({type: "SET_SOFTWARES_LIST", payload: { softwaresList: softwares }});
    }).catch(function (error) 
    {
        dispatch({type: "SET_LOADING_SOFTWARES", payload: { state: false },});
        errorResponse(null, error);
    });
  };
}

export function getAllControllersList(
  me: any,
  callbackFnSuccess?: any,
  callbackFnFailure?: any,
  page: number = 1,
  pageSize?: number
) 
{
  return async (dispatch: any) => 
  {
    Axios.get(appConfigs.server.URL + "/ui/api/controllers", 
    {
      responseType: "json",
      headers: {},
      params: {
        page: page,
        pageSize: pageSize,
      },
    }).then((response) => 
    {
        if (callbackFnSuccess != null)
        {
          callbackFnSuccess(response.data.data.controllers);
        }
        dispatch({type: "GET_CONTROLLERS_LIST", controllersList: response.data.data.controllers,});
      }).catch(function (error)
      {
        if (callbackFnFailure != null) 
        {
          callbackFnFailure(error);
        }
        errorResponse(me, error);
     });
  };
}
export function softwareCsuOrgGet(
  me: any, 
  callbackFnSuccess?: any,
  callbackFnFailure?: any,
  orgId?: string,
  searchText?: string)
{
  return async (dispatch: any) => 
  {            
      Axios.get(appConfigs.server.URL + "/ui/api/csu-orgs-lov" + ((orgId || "") !== "" ? "/" + orgId : ""),
      {
        responseType: "json",        
        headers: {},
        params: {
            mode: (orgId || "") === "" ? "all" : "single",
            scope: "all",
            includeTree: false,
            orgId: orgId,
            searchText: searchText,
            page: 1,
            pageSize: 9999
        }
      }).then(response => 
      {
          if (callbackFnSuccess != null) 
          {
            callbackFnSuccess(response.data.data.orgs);
          }
          dispatch({ type: "SOFTWARE_MAINT_ORGS_SUCCESS", payload: {data: response.data.data.orgs} });
        }
      )
      .catch(function (error) {
              errorResponse(me, error, false);
              if (callbackFnFailure != null) {
                  callbackFnFailure();
              }
          }
      );
  };
} 

export function SoftwareMaint(
  me: any,
  callbackFnSuccess?: any,
  callbackFnFailure?: any,
  softwareInfo?: any
) {

  return async (dispatch: any) => {
    //console.log("before calling post upload-csu-software softwareInfo", softwareInfo);
    var formData = new FormData();
    formData.append("orgId", softwareInfo.orgId);
    if (softwareInfo.mode !== "Add") {
      formData.append("systemSoftwareIdStr",softwareInfo.systemSoftwareId);
      formData.append("packageName",softwareInfo.packageName);
    } else {
      formData.append("systemSoftwareIdStr", "");
      formData.append("packageName","");
    }
    formData.append("name", softwareInfo.name);
    formData.append("version", softwareInfo.version);
    formData.append("packageName", softwareInfo.packageName);
    formData.append("mode", softwareInfo.mode);
    formData.append("availableToSubOrgs", softwareInfo.availableToSubOrgs);
    formData.append("description", softwareInfo.description);
    formData.append("devicemodel", softwareInfo.devicemodel);
    formData.append("softwaretype", softwareInfo.softwaretype);
    // formData.append("formatRevision", softwareInfo.formatRevision);
    // formData.append("numDevice", softwareInfo.numDeivce);
    // formData.append("numCsu", softwareInfo.numCsu);
    // formData.append("createdOn", softwareInfo.createdOn);
    // formData.append("csu", JSON.stringify(softwareInfo.csu));
    if (softwareInfo.mode === "Add") {
      formData.append("file", softwareInfo.fileUpload[0].originFileObj);
    }
    //console.log("post upload-csu-software formData", Object.fromEntries(formData));

    Axios(
      // "http://localhost:8080/ui/api/upload-csu-software",  
        appConfigs.server.URL + "/ui/api/upload-software-package",
      {
        method: "POST",
        data: formData,
        headers: { "Content-Type": "multipart/form-data;" },
        // params for org requires an UI to choose a suborg from the drop down list and only upload this one to the suborg.
        // currently, we shall assume this software is uploaded for the root customer org and shall be available to all its suborg
        // TODO for the DB function to view ancestor's org
        // params: {
          // orgId: orgId // "db7eb2e0-5849-11e7-893e-f94b4bc7246b",

        // },
      }
    ).then((response) => {
       //console.log("upload-csu-software response.data", response.data);
        if (callbackFnSuccess != null) {
          callbackFnSuccess(me, response.data.status);
        }

        dispatch({
          type: "SOFTWARE_MAINT_SUCCESS",
          payload: response.data.data.softwareUploads,
        });
      })
      .catch(function (error) {
        //console.log("error", error);
        if (callbackFnFailure != null) {
          callbackFnFailure(error);
        }
        errorResponse(me, error);
      });
  };

}


export function SoftwarePreview(
  me: any,
  callbackFnSuccess?: any,
  callbackFnFailure?: any,
  softwareInfo?: any
) {
  return async (dispatch: any) => {
    //console.log("softwareInfo", softwareInfo);
    // console.log("softwareInfo.fileUpload[0]", softwareInfo?.fileUpload[0]?.originFileObj);
    var formData = new FormData();

    formData.append("mode", "add");
    formData.append("file", softwareInfo[0].originFileObj);
    // formData.append("file", softwareInfo.fileUpload[0].originFileObj);
    //console.log("softwarePreview formData", softwareInfo[0].originFileObj)
    //console.log("url" ,appConfigs.server.URL +"/ui/api/software-preview")
    Axios(
      appConfigs.server.URL +"/ui/api/software-preview",
      {
        method: "POST",
        data: formData,
        headers: { "Content-Type": "multipart/form-data;" }
      }
    ).then((response) => {
        //console.log("Software-preview API response.data", response.data);
        if (callbackFnSuccess != null) {
          //console.log("calling callbackFnSuccess")
          callbackFnSuccess(response.data?.data?.profile, softwareInfo);
        }
        //console.log("SOFTWARE_PREVIEW_SUCCESS response.data", response.data)

      })
      .catch(function (error) {
       // console.log("Software preview error", error);
        if (callbackFnFailure != null) {
          callbackFnFailure(error);
        }
        dispatch({ type: "SOFTWARE_PREVUEW_FAILED", payload: "Failed" });
        errorResponse(me, error);
      });

  };

}

export function getControllers(
  me: any, 
  callbackFnSuccess: any,
  callbackFnFailure: any,  
  orgId: string) 
{
  return async (dispatch: any) => 
  {
      Axios.get(appConfigs.server.URL + "/ui/api/get_controllers", 
      {
        responseType: "json",        
        headers: {},
        params: {
            orgId: orgId,
        }
      }).then(response => 
        {   
          let data = response.data.data.getControllers == null || (response.data.data.getControllers.length || 0) === 0 ? [] : response.data.data.getControllers;
          if (callbackFnSuccess != null)
          {
            callbackFnSuccess(data);
          }
            dispatch({ type: "SOFTWARE_DEVICE_MODEL_SUCCESS", payload: {data: data} });
        }
      ).catch(function (error) 
      {
          if (callbackFnFailure != null) 
          {
              callbackFnFailure(me, error)
          }
          errorResponse(me, error);
      });
  };
}

export function downloadPackage(
  me: any,
  callbackSuccessFn: any,
  callbackErrorFn: any,
  url: string,
  fileType:FileType,
  fileName: string) 
{
  return async (dispatch: any) => 
  {
      Axios({
          url: url,
          method: "GET",
          responseType: "blob", 
      }).then(response => 
      {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();         
          if (callbackSuccessFn != null)
          {
            callbackSuccessFn(response.data.data.context);
          }
          dispatch({ type: "DOWNLOAD_FILE_SUCCESS", payload: {data: link} });
      }).catch(function (error) 
      {                
          errorResponse(me, error, false);
          if (callbackErrorFn != null) 
          {
              callbackErrorFn(error);
          }
      })
  }
}